import React from 'react';

const Logo = (props) => {
    const {
        type    = "dark",
        onClick = () => {}
    } = props;
    
    return (
        <div className={"logo d-flex justify-content-start align-items-center "+type}>
            <a className="m-0 p-0 h5 cursor-pointer" onClick={(event) => onClick(event)} href={'#'}>Conah Tucker</a>
        </div>
    );
}

export default Logo;